/** @flow */

import * as actions from "@modules/service/constants/actions";
import * as emailNotificationsReducer from "./reducers";
import initialState from "./state";
import type { EmailNotificationsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: EmailNotificationsState = initialState, action: Object): Object => {
  const act = {
    [actions.GetEmailNotifications]: emailNotificationsReducer.onGetEmailNotifications,
    [actions.GetEmailNotificationsSuccess]:
      emailNotificationsReducer.onGetEmailNotificationsSuccess,
    [actions.GetEmailNotificationsError]: emailNotificationsReducer.onGetEmailNotificationsError,

    [actions.GetEmailNotification]: emailNotificationsReducer.onGetEmailNotification,
    [actions.GetEmailNotificationSuccess]: emailNotificationsReducer.onGetEmailNotificationSuccess,
    [actions.GetEmailNotificationError]: emailNotificationsReducer.onGetEmailNotificationError,

    [actions.GetEmailNotificationAssignments]:
      emailNotificationsReducer.onGetEmailNotificationAssignments,
    [actions.GetEmailNotificationAssignmentsSuccess]:
      emailNotificationsReducer.onGetEmailNotificationAssignmentsSuccess,
    [actions.GetEmailNotificationAssignmentsError]:
      emailNotificationsReducer.onGetEmailNotificationAssignmentsError,

    [actions.GetEmailNotificationSchema]: emailNotificationsReducer.onGetEmailNotificationSchema,
    [actions.GetEmailNotificationSchemaSuccess]:
      emailNotificationsReducer.onGetEmailNotificationSchemaSuccess,
    [actions.GetEmailNotificationSchemaError]:
      emailNotificationsReducer.onGetEmailNotificationSchemaError,

    [actions.SetCurrentEmailNotification]: emailNotificationsReducer.onSetCurrentEmailNotification,
    [actions.SetEditedEmailNotification]: emailNotificationsReducer.onSetEditedEmailNotification,
    [actions.SetEmailNotificationAssignments]:
      emailNotificationsReducer.onSetEmailNotificationAssignments,

    [actions.SetShowAddEmailNotificationModal]: emailNotificationsReducer.onSetShowAddModal,
    [actions.SetShowEditEmailNotificationModal]: emailNotificationsReducer.onSetShowEditModal,
    [actions.SetShowDeleteEmailNotificationModal]: emailNotificationsReducer.onSetShowDeleteModal,

    [actions.UpdateEmailNotification]: emailNotificationsReducer.onUpdateEmailNotification,
    [actions.UpdateEmailNotificationSuccess]:
      emailNotificationsReducer.onUpdateEmailNotificationSuccess,
    [actions.UpdateEmailNotificationError]:
      emailNotificationsReducer.onUpdateEmailNotificationError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
